import { apiClient } from "helpers/api_helper";

export const GetStockReport = async (data: any) => {
    try {
        const response = await apiClient.get(`/api/v1/Report/GetStockReport`, data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const GetStockReportDetailes = async (data: any) => {
    try {
        const response = await apiClient.get(`/api/v1/Report/GetStockReportDetailes?`, data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};